const CenteredCardContent = function({ children }) {
  return (
    <div className="h-100pct d-f flex-column flex-center-all ta-c">
      {children}
    </div>
  );
}

module.exports = CenteredCardContent;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/centered-card-content.jsx